import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { CookiesInitStepDeclaration } from "./Steps/CookiesInitStep";

export const cookiesStartupFlow = new FlowDefinition("CookiesFlow");

cookiesStartupFlow.addStep(CookiesInitStepDeclaration);

cookiesStartupFlow.setStartStep("CookiesInit_Step");

export const cookiesStartupFlowDefinition = new StepDefinition({
    stepName: "CookiesFlow",
    stepFlow: cookiesStartupFlow,
    contextIsolation: false
})